export const formatProductType = (type: string): string => {
  return (
    {
      theme: 'Tema',
      item: 'Unidade',
      media: 'Objeto',
      discipline: 'Disciplina',
      course: 'Curso',
    }[type.toLowerCase()] ?? '-'
  );
};
